// maximum files allowed in the file input
export const MAX_FILES_PER_FILE_INPUT = 10;
